export default __webpack_public_path__ + "static/media/galeria_2022.5eccb9e1.jpg";